/**
 * hallmark critique · main
 * tokens locked from docs/design.md
 * states covered: n/a (bootstrap only)
 * mobile verified: 320 / 375 / 414 / 768
 * no fake chrome · no italic headers · no shadows · single clay accent per viewport
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/globals.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
